import { Phone } from "lucide-react";
import logo from "@/assets/oz-move-logo.webp";

const ServiceHeader = () => (
  <header className="bg-[#FFC300] sticky top-0 z-50">
    <div className="container flex flex-nowrap items-center justify-between gap-4 py-3 whitespace-nowrap">
      <a href="/" className="shrink-0" aria-label="OZ MOVE CO. home">
        <img
          src={logo}
          alt="OZ MOVE CO. Logo"
          className="h-14 md:h-20 w-auto"
          width="288"
          height="192"
        />
      </a>
      <div className="flex flex-nowrap items-center gap-2 md:gap-3 shrink-0">
        <a
          href="tel:1800556654"
          aria-label="Call 1800 556 654"
          className="inline-flex items-center gap-2 border-2 border-[#1a1a1a] text-[#1a1a1a] px-3 md:px-4 py-2 font-bold text-sm rounded-full hover:bg-[#1a1a1a]/5 transition-colors whitespace-nowrap shrink-0"
        >
          <Phone className="w-4 h-4 shrink-0" />
          <span className="hidden lg:inline">1800 556 654</span>
        </a>
        <a
          href="/#quote"
          className="inline-flex bg-[#1a1a1a] text-[#FFC300] px-4 md:px-5 py-2 font-bold text-sm rounded-full hover:opacity-90 transition-opacity whitespace-nowrap shrink-0"
        >
          Get Free Quote
        </a>
      </div>
    </div>
  </header>
);

export default ServiceHeader;